import {http} from "@/config/HttpClient";
import {AxiosResponse} from "axios";
import {Alert} from "@/addons/Alert";
import {anulacionStore} from "@/store/anulacionStore";

export class AnulacionService {
    private static instance: AnulacionService;
    public static getInstance(): AnulacionService {
        return this.instance || (this.instance = new this());
    }

    anulacionStore = anulacionStore();

    public async getMotivosAnulacion() {
        await http.get("getCodigosAnulacion").subscribe({
            next: (response:AxiosResponse) => {
                this.anulacionStore.motivos = response.data;
            },
        })
    }

    public async index() {
        this.anulacionStore.loading = true;
        await http.get("anulaciones").subscribe({
            next: (response:AxiosResponse) => {
                this.anulacionStore.anulaciones = response.data;
                this.anulacionStore.loading = false;
            },
        })
    }

    public async setAnulacion(data: any){
        this.anulacionStore.loading = true;
        await http.post(`setAnulacion`, data).subscribe({
            next: (response: AxiosResponse) => {
                this.anulacionStore.loading = false;
                Alert.success(response.data.message);
                this.index();
                this.anulacionStore.isNewDialog = false;
            },
            error: (error) => {
                this.anulacionStore.loading = false;
                Alert.error(error.message + '<br/><br/>' + error.response.data.message);
            }
        })
    }
}